<template>
  <b-button class="add-button" :class=" [{ bypass: isDisabled }, customClass ? customClass : '']">
    <div class="d-flex align-items-center">
      <icon-star class="mr-2" v-if="!setIcon" />
      <icon-rewards class="mr-2" v-else />
      <span>{{ btnLabel }}</span>
    </div>
  </b-button>
</template>

<script>
import { BButton } from "bootstrap-vue";
import { computed } from "@vue/composition-api";
import IconStar from "@/@core/components/svg/common/IconStar.vue";
import IconRewards from "@/@core/components/svg/common/IconRewards.vue";

export default {
  components: {
    BButton,
    IconStar,
    IconRewards,
  },
  props: {
    btnLabel: { type: String },
    setIcon: { type: Boolean, default: false },
    customClass: { type: String },
    isDisabled: { type: Boolean, default: true },
  },
  setup(props) {
    return {};
  },
};
</script>

<style scoped>
.add-button {
  padding: 0.5rem 0.8rem;
  border-radius: 0.5rem;
  font-size: 20px;
  color: #007bff !important;
  border-color: #007bff !important;
  background-color: unset !important;
}

.add-button svg {
  width: 17px;
  fill: #006aff;
}

</style>
